import generate_image_sources from "./image_sources.js"

$(document).ready(function(){
    const PADDING = 150
    const LERP_STEP = 3/100
    const ALPHA_STEP = 1.0 / 20
    const SCROLL_SCALE = 10
    const SCROLL_TRAP = 10

    const firebaseConfig = {
        apiKey: "AIzaSyBqNFvFVDJZpFP3YdHtK-RQhcH-WV8Jm7g",
        authDomain: "distancing-ab124.firebaseapp.com",
        databaseURL: "https://distancing-ab124.firebaseio.com",
        projectId: "distancing-ab124",
        storageBucket: "distancing-ab124.appspot.com",
        messagingSenderId: "527211880222",
        appId: "1:527211880222:web:3553d23b6670387f71730f",
        measurementId: "G-DDY4BL60RG",
        functionsURL: "https://us-central1-distancing-ab124.cloudfunctions.net"
    };
    firebase.initializeApp(firebaseConfig);
    var analytics = firebase.analytics();
    var perf = firebase.performance();

    const copyToClipboard = str => {
        const el = document.createElement('textarea');
        el.value = str;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
    };

    var raf = undefined
    var animation_cb = undefined
    var my_request_animation_frame_cb = function(ts) {
        // console.log("my_request_animation_frame_cb " + animation_cb.name)
        raf = undefined
        animation_cb(ts)
    }
    var my_request_animation_frame = function(cb) {
        if (raf === undefined) {
            // console.log("my_request_animation_frame - restart. " + cb.name)
            // No running animation, restart
            animation_cb = cb
            raf = window.requestAnimationFrame(my_request_animation_frame_cb)
        } else {
            // console.log("my_request_animation_frame - continue. " + cb.name)
            // Already running animaiton, update cb
            animation_cb = cb
        }
    }
    var my_cancel_animation_frame = function() {
        // console.log("my_cancel_animation_frame")
        window.cancelAnimationFrame(raf)
        raf = undefined
        animation_cb = undefined
    }

    var hit_count = undefined
    var render_gallery_visitors = function() {
        if (hit_count === undefined) {
            return
        }
        if ($('#gallery_visitors').length === 0) {
            var f = document.createElement("span");
            f.id = "gallery_visitors";
            f.classList.add('fade')
            f.classList.add('gallery')
            f.classList.add('no_pointer')
            f.classList.add('visitors')
            f.innerHTML = "<span class=\"visitor_count\">" + hit_count + "</span>"
                + "<br />"
                + "<span  class=\"visitor_text\">Visitors</span>"
            canvas.parentNode.appendChild(f);
            $('#gallery_visitors').css("top", 30)
            $('#gallery_visitors').css("right", 30)
        }
    }
    fetch(firebaseConfig.functionsURL + "/hitCounter").then(res => {
        res.text().then(v => {
            hit_count = v
            render_gallery_visitors()
        }).catch(e => {
            console.error(e)
        })
    }).catch(e => {
        console.error(e)
    })

    $('body').on('contextmenu', '#canvas', function(e){ return false; });
    $('body').on('contextmenu', '#canvas_onboarding', function(e){ return false; });

    
    var canvas = document.getElementById("canvas")
    var ctx = canvas.getContext('2d')
    canvas.width  = window.innerWidth
    canvas.height = window.innerHeight
    var canvas_onboarding = document.getElementById("canvas_onboarding")
    var ctx_onboarding = canvas_onboarding.getContext('2d')
    canvas_onboarding.width  = window.innerWidth
    canvas_onboarding.height = window.innerHeight

    console.log('canvas ' + canvas.width + ' ' + canvas.height)
    const image_sources = generate_image_sources(canvas)

    var room_to_sources = {}
    for (var i = 0; i < image_sources.length; i++) {
        const element = image_sources[i];
        if (!element.type.startsWith('room_')) {
            continue
        }
        const room_id = element.room_id
        if (element.type.endsWith('vid') || element.type.endsWith('img')) {
            if (room_to_sources[room_id] === undefined) {
                room_to_sources[room_id] = [i]
            } else {
                room_to_sources[room_id].push(i)
            }
        }
    }
    
    var render = function() {}
    var mouse = { x: canvas.width/2, y: canvas.height/2 }
    var mouse_smooth = Object.assign({}, mouse)
    var lerp = {
        v0: Object.assign({}, mouse),
        v1: Object.assign({}, mouse),
        t: 1
    }
    var do_lerp = function(ev) {
        if ((do_lerp.debounce !== undefined) && do_lerp.debounce > 0) {
            // console.log(do_lerp.debounce)
            do_lerp.debounce -= 1
            if (do_lerp.debounce === 0) {
                var delta = SCROLL_TRAP
                if (mouse.y < mouse_smooth.y) {
                    delta = -delta
                }
                mouse = Object.assign({}, mouse_smooth)
                mouse.y += delta
                lerp = {
                    v0: Object.assign({}, mouse),
                    v1: Object.assign({}, mouse),
                    t: 1
                }
            } else {
                return
            }
        }
        if ((mouse.x !== lerp.v1.x) || (mouse.y !== lerp.v1.y)) {
            // console.log('motion: dest changed')
            // Destination changed, reset lerp
            lerp.v0.x = mouse_smooth.x
            lerp.v0.y = mouse_smooth.y
            lerp.v1.x = mouse.x
            lerp.v1.y = mouse.y
            lerp.t    = LERP_STEP
            mouse_smooth.x = Math.round(lerp.v0.x*(1-lerp.t)+lerp.v1.x*lerp.t)
            mouse_smooth.y = Math.round(lerp.v0.y*(1-lerp.t)+lerp.v1.y*lerp.t)
            // render
            render()
            // animate
            my_request_animation_frame(do_lerp)
            return
        } else {
            // console.log('motion: dest hasnt changed')
            // Destination hasn't changed
            // update t
            lerp.t += LERP_STEP
            lerp.t = Math.min(lerp.t, 1)
            // Update mouse_smooth and render
            const v0x = lerp.v0.x
            const v0y = lerp.v0.y
            const v1x = lerp.v1.x
            const v1y = lerp.v1.y
            var t   = lerp.t
            mouse_smooth.x = Math.round(v0x*(1-t)+v1x*t)
            mouse_smooth.y = Math.round(v0y*(1-t)+v1y*t)
            render()
            // keep animating
            my_request_animation_frame(do_lerp)
        }
        if (onboarding_opacity > 0) {
            // Don't stop animating if we're still onboarding
            return
        }
        if (lerp.t >= 1) {
            // console.log('motion: dest reached')
            // Destination reached, render and stop animation
            render()
            my_cancel_animation_frame()
        }
    }
    var mousemove = function(ev){
        if (room !== undefined) {
            return
        }
        if (fade_state !== 0) {
            return
        }
        mouse.x = ev.offsetX
        mouse.y = ev.offsetY
        my_request_animation_frame(do_lerp)
    }
    
    $("#canvas").mousemove(mousemove)
    var get_camera = function() {
        var x = (canvas.width - mouse_smooth.x)
        var y = (canvas.height- mouse_smooth.y)
        return { x:x, y:y }
    }
    var fade_state = 0
    var fade_entering_room = true
    var start_fade = function() {
        // console.log("start_fade")
        if (room !== room_pending) {
            // Entering room
            fade_entering_room = true
        } else {
            // Leaving room
            fade_entering_room = false
        }
        my_cancel_animation_frame()
        ctx.globalAlpha = 1
        fade_state = -1
        my_request_animation_frame(do_fade)
    }

    var return_to_mouse = { x: canvas.width/2, y: canvas.height/2 }
    var do_fade = function() {
        // my_cancel_animation_frame()
        ctx.globalAlpha += fade_state * ALPHA_STEP
        $('.fade').css("opacity", ctx.globalAlpha)
        if (ctx.globalAlpha < ALPHA_STEP) {
            fade_state = 1
            if (fade_entering_room) {
                room = room_pending
                $('.fade.gallery').remove()
                // Save mosue for later
                return_to_mouse = Object.assign({}, mouse_smooth)
                // Reset mouse 
                mouse = { x: 0, y: 200 }
                mouse_smooth = Object.assign({}, mouse)
            } else {
                room = undefined
                max_mousewheel = undefined
                min_mousewheel = undefined
                $('.fade.room').remove()
                mouse = Object.assign({}, return_to_mouse)
                mouse_smooth = Object.assign({}, mouse)
            }
        }
        // console.log(ctx.globalAlpha)
        render()
        if (ctx.globalAlpha > (1-ALPHA_STEP)) {
            my_cancel_animation_frame()
            my_request_animation_frame(do_lerp)
            fade_state = 0
            if (!fade_entering_room) {
                room_pending = undefined
            }
        } else {
            // More fading to animate
            my_request_animation_frame(do_fade)
        }
    }
    var room_pending = undefined
    var room = undefined
    var hovered_image = undefined
    var enter_room = function() {
        const room_id = hovered_image.index
        analytics.logEvent('enter_room', { room_id: room_id});
        // analytics.logEvent('view_item', { item_id: room_id});
        console.log("Welcome to room number " + room_id)
        room_pending = room_id
        // Cancel previous animations if pending and re-animate with new state
        my_cancel_animation_frame()
        my_request_animation_frame(start_fade)
    }
    var leave_room = function() {
        analytics.logEvent('leave_room', { room_id: room});
        console.log("Leaving room number " + room)
        // Cancel previous animations if pending and re-animate with new state
        my_cancel_animation_frame()
        my_request_animation_frame(start_fade)
    }
    $("#canvas").click(function() {
        if (onboarding_opacity > 0) {
            return
        }
        if (room_pending === undefined && hovered_image !== undefined) {
            enter_room()
        }
        // if ((room !== undefined) && (fade_state === 0)) {
        //     leave_room()
        // }
    })
    
    var min_mousewheel = undefined
    var max_mousewheel = undefined
    var mousewheel = function(ev) {
        if (room === undefined) {
            return
        }
        if (fade_state !== 0) {
            return
        }
        const delta = Math.round(ev.originalEvent.wheelDeltaY / SCROLL_SCALE)
        if (Math.abs(delta) < 10) {
            return
        }
        mouse.y += delta
        mousewheel.integrate_sum = 0
        mousewheel.integrate_num = 0
        if (max_mousewheel !== undefined) {
            mouse.y = Math.min(mouse.y, max_mousewheel)
        }
        if (min_mousewheel !== undefined) {
            mouse.y = Math.max(mouse.y, min_mousewheel)
        }
        if ((Math.abs(mouse_smooth.y - min_mousewheel) < 20) && (mouse.y <= mouse_smooth.y) && (fade_state === 0)) {
            leave_room()
        } else {
            my_request_animation_frame(do_lerp)
        }
        // console.log(mouse.y + ' ' + mouse_smooth.y)
    }
    $(window).on({ 'DOMMouseScroll mousewheel': mousewheel});



    var imgs_store = {}
    const image_load_trace = perf.trace('imageLoad');
    image_load_trace.start()
    const user_interaction_trace = perf.trace('userInteraction');
    user_interaction_trace.start()
    var image_load_total_num = 0
    var image_load_done_num = 0
    for (let i = 0; i < image_sources.length; i++) {
        if (!image_sources[i].type.endsWith("img")) {
            continue
        }
        image_load_total_num += 1
        var img = new Image;
        img.onload = function() {
            // console.log("Image loaded");
            this.initial_dx = image_sources[i].initial_dx
            this.initial_dy = image_sources[i].initial_dy
            this.index = image_sources[i].room_id
            this.loaded = true
            // ctx.drawImage(this, this.initial_dx, this.initial_dy);
            my_request_animation_frame(do_lerp)
            image_load_done_num += 1
            image_load_trace.incrementMetric('numberImages', 1);
            if (image_load_done_num === image_load_total_num) {
                image_load_trace.stop()
                user_interaction_trace.putAttribute("imageLoadComplete", image_load_total_num.toString())
            }
        }
        const src = image_sources[i].src
        img.src = src
        imgs_store[src] = img
    }

    const initial_onboarding_opacity = 0.7
    var onboarding_opacity = initial_onboarding_opacity
    var render_gallery_onboarding = function() {
        if (onboarding_opacity > 0) {
            ctx_onboarding.clearRect(0, 0, canvas_onboarding.width, canvas_onboarding.height)
            ctx_onboarding.globalAlpha = onboarding_opacity
            ctx_onboarding.fillRect(0, 0, canvas_onboarding.width, canvas_onboarding.height)

        } else {
            $('.onboarding').remove()
            ctx_onboarding.clearRect(0, 0, canvas_onboarding.width, canvas_onboarding.height)
            onboarding_opacity = 0
        }
        if ((onboarding_opacity !== initial_onboarding_opacity) && (onboarding_opacity > 0)) {
            onboarding_opacity -= 0.01
            $('.onboarding').css("opacity", onboarding_opacity)
        }
    }
    var run_onboarding = function() {
        const timoeut_duration = 1000
        var line_1 = undefined
        var line_2 = undefined
        var line_3 = undefined
        var loader = undefined
        var line_4 = undefined
        var onboarding_start_ts = Date.now()

        line_1 = function() {
            $('#onboarding_line_1').css("opacity", 1)
            setTimeout(line_2, timoeut_duration)
        }
        line_2 = function() {
            $('#onboarding_line_2').css("opacity", 1)
            setTimeout(line_3, timoeut_duration)
        }
        line_3 = function() {
            $('#onboarding_line_3').css("opacity", 1)
            setTimeout(loader, timoeut_duration)
        }
        loader = function() {
            $('#onboarding_loader').css("opacity", 1)
            if ((image_load_done_num === image_load_total_num) || ((Date.now() - onboarding_start_ts) > 15000)) {
                $('#onboarding_loader').css("opacity", 0)
                // $('#onboarding_loader').css("display", "none")
                line_4()
            } else {
                setTimeout(loader, timoeut_duration/10)
            }
        }
        line_4 = function() {
            $('#onboarding_line_4').css("opacity", 1)
            $('#onboarding_line_4').click(ev => {
                onboarding_opacity -= 0.01
                user_interaction_trace.stop()
                image_load_trace.putAttribute("userInteraction", image_load_done_num.toString())
                analytics.logEvent('click_enter', {done_num: image_load_done_num});
            })
        }
        
        setTimeout(line_1, timoeut_duration)
    }

    var render_gallery = function() {
        const cam = get_camera()
        const x = cam.x
        const y = cam.y
        hovered_image = undefined
        render_gallery_visitors()
        for (var i = 0; i < image_sources.length; i++) {
            const source = image_sources[i]
            const element = imgs_store[source.src]
            
            if ((!source.type.startsWith('gallery')) || (element.loaded === undefined)) {
                continue;
            }
            
            const cam_delta_x = mouse.x + mouse_smooth.x - canvas.width  - element.initial_dx
            const cam_delta_y = mouse.y + mouse_smooth.y - canvas.height - element.initial_dy 
            var element_scale = 1
            if ((Math.abs(cam_delta_x) < element.width/2) && (Math.abs(cam_delta_y) < element.height/2)) {
                element_scale = 1.5
                hovered_image = element
            }
            
            const img_height = element.height * element_scale
            const img_width  = element.width * element_scale
            const dx = (element.initial_dx + x) - img_width/2
            const dy = (element.initial_dy + y) - img_height/2
            if ((dx < canvas.width) && (dy < canvas.height) &&
                ((dx + img_width) >= 0) && ((dy + img_height) >= 0)) 
            {
                ctx.drawImage(element, dx, dy, img_width, img_height);
            }
        }

        const title_initial_dx = -canvas.width*2/5
        const title_initial_dy = -canvas.height/3
        const title_dx = (title_initial_dx + x)
        const title_dy = (title_initial_dy + y)
        if ($('#gallery_title').length === 0) {
            var f = document.createElement("span");
            f.id = "gallery_title";
            f.classList.add('fade')
            f.classList.add('gallery')
            f.classList.add('no_pointer')
            f.classList.add('title')
            f.innerHTML = "The Intimacy Of<br/><span style='text-decoration: line-through;'>Social</span> Distancing"
            f.style.cssText = "font-size: 50px;"
            canvas.parentNode.appendChild(f);
        }
        $('#gallery_title').css("top", title_dy)
        $('#gallery_title').css("left", title_dx)

        const text_initial_dx = title_initial_dx + $('#gallery_title').width() + 100
        const text_initial_dy = title_initial_dy
        const text_dx = (text_initial_dx + x)
        const text_dy = (text_initial_dy + y)

        if ($('#gallery_text').length === 0) {
            var f = document.createElement("span");
            f.id = "gallery_text";
            f.classList.add('fade')
            f.classList.add('gallery')
            f.classList.add('no_selection')
            f.classList.add('heebo')
            f.innerHTML = "<p>Don’t leave home unless necessary for food or medicine shopping. Don’t go to parks, swimming pools, libraries, museums, the beach, or other public spaces. Walk your dog on your own, no further than 100 meters from your house. Don’t go to the gym and other physical or cultural activities. Maintain social relations from afar, don’t host people in your house, and keep a two-meter distance from others outside your household. Use delivery services for shopping. Don’t use public transport. Don’t go to work; work from home using video conferences and calls. Postpone any unnecessary dental treatments until further notice. Don’t go to the doctor; use remote clinic services. Avoid any physical contact, including hugs and handshakes. Don’t open doors with the palm of your hand. Avoid touching your face. Wash your hands frequently. Ventilate your house. Disinfect doors and handles. Avoid kissing the mezuzah and other religious articles. Avoid smoking cigarettes of any kind. Avoid sharing dinnerwear and cutlery. Maintain healthy nutrition and physical activity while staying at home.  </p>"
             + "<p>These new rules have been slowly applied to everyone, everywhere; for the first time in ages - money, social status, religion, race, or geography just don’t matter. No one is safe. There is no way to avoid the plague. In the interconnected, global, and abundant world of FOMO we are all sentenced to isolation. No more filling your calendar with after-work activities, social encounters, cultural activities, and romantic dates. It’s just you. On your own.  </p>"
             + "<p>What happens to intimacy in this new reality? While in the pre-coronavirus world we used to criticize technology and smartphones as phenomena that isolate us from our surroundings, today these are crucial tools for creating intimacy. When the most human thing to do is staying away from other humans, we feel like going back to an ancient civilization, but we stay alive thanks to the infamous technology. Can this new order be applied to the art world? Can we connect with an artwork without facing it in reality? Can it move us, touch us, from afar? What happens to the experience of consuming art virtually in an interactive, immersive, and isolated art scene? Participating artists in the exhibition investigate their personal interpretation of intimacy, while the curators wish to explore its impact on the observer through the screen. </p>"
             + "<p>Curators: Inbal Sinai and Dalit Steinbrecher Participating artists: Alla Sorokina, Anastasya Chernyak, Arava Assaf, Cooike Moon, Déborah Kempczynski, Diana Toloza, Fabienne Forel, Enes Guc, Itzik Mor, Julian Ochoa, Luis Preto, Marta Wlusek, Michael Liani, Natalia Evelyn Bencicova, Natalie Feldesman, Noa Macabbi, Maya Agam, Orly Anan, Romy Engel, Shay Ben Ari, Shira Kela, Urizen Freaza, Vegetal Import Festival (Giulia Currà + Steve Piccolo), Yuval Atzili, Zaida Kersten. User experience and Website design: Dalit Steinbrecher Website development: Ben Lapid Texts: Inbal Sinai </p>"
            f.style.cssText = "position:absolute; \
                width: 550px; \
                text-align: left; \
                font: Regular Heebo; \
                font-size: 12px; \
                letter-spacing: 0px; \
                color: #676767; \
                pointer-events: none;"
            canvas.parentNode.appendChild(f);
        }
        $('#gallery_text').css("top", text_dy)
        $('#gallery_text').css("left", text_dx)
        

        if ($('#gallery_share').length === 0) {
            var f = document.createElement("span");
            f.id = "gallery_share";
            f.classList.add('fade')
            f.classList.add('gallery')
            f.classList.add('share')
            f.classList.add('no_selection')
            f.innerHTML = "Share"
            canvas.parentNode.appendChild(f);
            $('#gallery_share').click(ev => {
                if (onboarding_opacity > 0) {
                    return
                }
                const url = window.location.href;
                window.open('https://www.facebook.com/sharer/sharer.php?u=' + url,
                'facebook-share-dialog',
                'width=800,height=600'
                );
                analytics.logEvent('click_share', {});
                return false;
            })
        }
        $('#gallery_share').css("bottom", 30)
        $('#gallery_share').css("right", 200)

        if ($('#gallery_write_us').length === 0) {
            var f = document.createElement("span");
            f.id = "gallery_write_us";
            f.classList.add('fade')
            f.classList.add('gallery')
            f.classList.add('write_us')
            f.classList.add('no_selection')
            f.innerHTML = "Say something"
            canvas.parentNode.appendChild(f);
            $('#gallery_write_us').click(ev => {
                if (onboarding_opacity > 0) {
                    return
                }
                copyToClipboard("sinainbal@gmail.com")
                var p = document.createElement("span")
                p.id = "gallery_write_us_popup"
                p.classList.add('fade')
                p.classList.add('gallery')
                p.classList.add('no_pointer')
                p.classList.add('popup')
                p.innerHTML = "email copied!"
                p.style.cssText = "bottom: 60px; right: 50px;"
                canvas.parentNode.appendChild(p)
                $(p).on("animationend", function(){
                    $(p).remove()
                });
                analytics.logEvent('click_write_us', {});
            })
        }
        $('#gallery_write_us').css("bottom", 30)
        $('#gallery_write_us').css("right", 50)

        $('.fade').css("opacity", ctx.globalAlpha)
        $("#gallery_text").css("opacity", Math.min(ctx.globalAlpha, 1-2*onboarding_opacity))

        render_gallery_onboarding()
    }
    var render_room = function() {
        const room_sources_indices = room_to_sources[room]
        if (room_sources_indices === undefined) {
            return
        }
        var room_sources = []
        for (var i = 0; i < room_sources_indices.length; i++) {
            const source_index = room_sources_indices[i];
            room_sources.push(image_sources[source_index])
        }

        if ($('#room_title').length === 0) {
            var f = document.createElement("span");
            f.id = "room_title";
            f.classList.add('fade')
            f.classList.add('room')
            f.classList.add('no_selection')
            // f.classList.add('no_pointer')
            f.classList.add('title')
            f.innerHTML = "The Intimacy Of<br/><span style='text-decoration: line-through;'>Social</span> Distancing"
            f.style.cssText = "font-size: 30px;"
            f.addEventListener("click", function() {
                if (onboarding_opacity > 0) {
                    return
                }
                leave_room()
            })
            canvas.parentNode.appendChild(f);
        }
        $('#room_title').css("top", 40)
        $('#room_title').css("left", 40)

        if ($('#room_back').length === 0) {
            var f = document.createElement("span");
            f.id = "room_back";
            f.classList.add('fade')
            f.classList.add('room')
            f.classList.add('no_selection')
            // f.classList.add('no_pointer')
            f.classList.add('back')
            f.innerHTML = "Back to Gallery"
            f.addEventListener("click", function() {
                if (onboarding_opacity > 0) {
                    return
                }
                leave_room()
            })
            canvas.parentNode.appendChild(f);
        }
        $('#room_back').css("top", 115)
        $('#room_back').css("left", 40)

        const x = mouse_smooth.x
        var y = mouse_smooth.y
        y = Math.min(300, y)

        var sum_height = 0;
        var sources_y = Array(room_sources.length)

        for (var i = 0; i < room_sources.length; i++) {
            const source = room_sources[i];
            const dont_rotate = source.dont_rotate === true

            if (source.type === 'room_img') {
                const img = imgs_store[source.src]
                const img_x = canvas.width/2 - img.width/2
                const img_y =  Math.min(img.height/2, y) + sum_height

                if ((render_room.transition_i !== i) && (img_y < (PADDING+SCROLL_TRAP)) && (img_y > (PADDING))) {
                    do_lerp.debounce = 10
                    render_room.transition_i = i
                    // console.log("?? " + img_y)
                }

                sources_y[i] = img_y

                // All but last one
                if (i < room_sources.length -1) {
                    const img_pad = (source.dont_pad === true) ? (0) : (PADDING)
                    sum_height += img.height + img_pad
                }
                if ((img_y >= -2*PADDING) && (img_y < canvas.height) ){
                    // const img_radians = -Math.abs(Math.min(0, (img_y - img.height/2) / (img.height)))
                    const img_radians = -Math.abs(Math.min(0, (img_y - PADDING) / (img.height)))
                    ctx.save()
                    ctx.translate(img_x, img_y);
                    if (!dont_rotate) {
                        ctx.rotate(img_radians);
                    }
                    ctx.drawImage(img, 0, 0);
                    // untranslate and unrotate
                    ctx.restore()
                }
            } else if (source.type == 'room_vid') {
                const vid_width = source.width
                const vid_height = source.height
                const vid_x = canvas.width/2 - vid_width/2
                const vid_y = y + sum_height

                if ((render_room.transition_i !== i) && (vid_y < (PADDING+SCROLL_TRAP)) && (vid_y > (PADDING))) {
                    do_lerp.debounce = 10
                    render_room.transition_i = i
                    // console.log("?? " + img_y)
                }

                sources_y[i] = vid_y

                // All but last one
                if (i < room_sources.length -1) {
                    sum_height += vid_height + PADDING
                }

                if ($('#room_vid_'+i).length === 0) {
                    var f = document.createElement("iframe");
                    f.id = "room_vid_"+i;
                    f.classList.add('fade')
                    f.classList.add('room')
                    f.allow = "autoplay; encrypted-media";
                    f.frameBorder = "0";
                    f.setAttribute("allowfullscreen", "")
                    f.style.cssText = "left:" + (vid_x) + "px; top:" + (vid_y) + 
                        "px; width:" + vid_width + "px; height:" + vid_height + "px;";
                    f.src = source.src
                    canvas.parentNode.appendChild(f);
                    f.contentWindow.document.onmousewheel=function(event){
                        // console.log("??")
                        mousewheel(event)
                    };
                }
                $('#room_vid_'+i).css("top", vid_y)
            }
        }

        var cur_source_i = undefined
        for (var i = 0; i < room_sources.length; i++) {
            const source = room_sources[i];
            
            if ((cur_source_i === undefined) && (sources_y[i] >= -PADDING)) {
                cur_source_i = i
            }
        }

        var cur_source = room_sources[cur_source_i]
        var cur_source_y = sources_y[cur_source_i]
        var prev_source = undefined
        var prev_source_y = undefined
        if (cur_source_i > 0) {
            prev_source = room_sources[cur_source_i-1]
            prev_source_y = sources_y[cur_source_i-1]
        }
        
        var opacity = 1
        if ((cur_source_y < 0) && (cur_source_y >= -PADDING)) {
            opacity = 1 - (-cur_source_y / PADDING)
        } else if (prev_source_y !== undefined) {
            if ((prev_source_y < -PADDING) && (prev_source_y > -2*PADDING)) {
                opacity = ((-prev_source_y-PADDING) / PADDING)
            }
        }

        if (cur_source !== undefined) {

            if ((($('#room_caption').length === 0))) {
                const txt = cur_source
                var f = document.createElement("span");
                f.id = "room_caption";
                f.classList.add('fade')
                f.classList.add('room')
                f.classList.add('no_pointer')
                canvas.parentNode.appendChild(f);
            }
            const name = (cur_source.name !== "") ? ("#" + cur_source.name) : ("")
            const artist = (cur_source.artist !== "") ? (cur_source.artist + ", ") : (cur_source.artist)
            $('#room_caption').html(
                "<span class=\"caption_name\">" + name + "</span>" +
                "<br />" +
                "<span class=\"caption_artist\">" + artist + "</span>" +
                "<span class=\"caption_country\">" + cur_source.country + "</span>" +
                "<br />" +
                "<span class=\"caption_technique\">" + cur_source.technique + "</span>"
            )
            $('#room_caption').css("bottom", 40)
            $('#room_caption').css("left", 40)
            $('#room_caption').css("opacity", opacity)
            
            if (($('#room_description').length === 0)) {
                var f = document.createElement("div");
                f.id = "room_description";
                f.classList.add('fade')
                f.classList.add('room')
                f.classList.add('no_pointer')
                f.classList.add('vertical_center_content')
                canvas.parentNode.appendChild(f);
            }
            $('#room_description').html(
                "<div class=\"caption_description\">" + cur_source.description + "</div>"
            )
            $('#room_description').css("top", 0)
            $('#room_description').css("left", 40)
            $('#room_description').css("opacity", opacity)

            if (($('#room_scroll').length === 0)) {
                var f = document.createElement("div");
                f.id = "room_scroll";
                f.classList.add('fade')
                f.classList.add('room')
                f.classList.add('no_pointer')
                f.classList.add('icon-scroll')
                canvas.parentNode.appendChild(f);
            }
            $('#room_scroll').css("bottom", 100)
            $('#room_scroll').css("right", 40)
            const room_scroll_opacacity = Math.min(1, Math.max(y, 0) / PADDING)
            $('#room_scroll').css("opacity", room_scroll_opacacity)
        }


        max_mousewheel = 300
        min_mousewheel = -(sum_height -PADDING)
        
    }

    render = function() {
        ctx.clearRect(0, 0, canvas.width, canvas.height)
        if (room === undefined) {
            render_gallery()
        } else {
            render_room()
        }
    }
    my_request_animation_frame(do_lerp)
    run_onboarding()
});